export default __webpack_public_path__ + "static/professor-536e1b3964fa72f83684f16f22376624.png";